import React from 'react';
import { FormGroup, Input, Label } from 'reactstrap';

const RadioButtonForm = ({ options, selectedOption, onChange, name = 'verificationOption' }) => {
    return (
        <>
            {options.map((option, index) => (
                <FormGroup key={index} check>
                    <Label check>
                        <Input
                            type="radio"
                            name={name}
                            value={option.value}
                            checked={selectedOption === option.value}
                            onChange={() => onChange(option.value)}
                        />
                        {' '}
                        {option.label}
                    </Label>
                </FormGroup>
            ))}
        </>
    );
};

export default RadioButtonForm;
